import React from 'react';
import {observer} from 'mobx-react';
import DOMPurify from 'dompurify';
import {EPLines} from './ep-lines';
import {EPMethod, PCS_CSS, ProductCustomizationState} from '../../../rendering/render.def';

type Props = {
    css: PCS_CSS;
    pcs: ProductCustomizationState;
};

export const EPContent: React.FC<Props> = observer(({pcs, css}: Props) => {
    const isEPCustom = pcs.EPMethodID === EPMethod.Custom;
    const isEPSingleDoc = pcs.EPMethodID === EPMethod.SingleDoc;
    const showEditor = isEPCustom || isEPSingleDoc;
    const isImageGen = typeof window !== 'undefined' && window.location.pathname.includes('/stack2');
    const scaleFactorForImageGenFont = 0.47;
    const scaleFactorForImageGenLine = 0.71;

    const epStyle: React.CSSProperties = {
        backgroundImage: css.ep_backgroundImage,
        backgroundSize: css.ep_backgroundSize,
        color: showEditor ? undefined : css.ep_color,
        left: css.ep_left,
        top: css.ep_top,
        width: css.ep_width,
        height: css.ep_height,
        textAlign: showEditor ? 'initial' : 'center',
        wordBreak: showEditor ? 'break-word' : undefined,
        overflow: showEditor ? 'hidden' : undefined,
        fontSize: showEditor && isImageGen ? `${pcs.DPI * scaleFactorForImageGenFont}px` : undefined,
        lineHeight: showEditor && isImageGen ? `${pcs.DPI * scaleFactorForImageGenLine}px` : undefined,
        display: showEditor ? 'flex' : undefined,
        flexDirection: showEditor ? 'column' : undefined,
        justifyContent: showEditor ? 'center' : undefined,
    };

    return (
        <div
            id="ep"
            style={epStyle}
        >
            {showEditor ? (
                <div
                    style={{width: '100%'}}
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(pcs.EPContent || '', {
                            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 's', 'span', 'ul', 'ol', 'li', 'div'],
                            ALLOWED_ATTR: ['style', 'class'],
                            ALLOW_DATA_ATTR: false,
                        }),
                    }}
                ></div>
            ) : (
                <EPLines
                    pcs={pcs}
                    css={css}
                />
            )}
        </div>
    );
});
